<script>
import chatMessage from "../components/chatMessage";

export default {
  name: "chat-log",
  components: {
    chatMessage,
  },
  props: {
    refreshLogUser: Number,
    refreshLogRemote: Number,
    generalOnly: Boolean,
    inlineChat: Boolean,
  },
  data: function() {
    return {
      loadedMessages: [],
      loadedChunks: 0,
      lastChunk: 1,
      scrollBottom: true,
      newMessageNotification: false,
    };
  },
  methods: {
    async loadNextChunk(forceScroll) {
      this.loadedMessages = this.activeBidId
        ? await this.$store.dispatch("getRequest", { controller: "chat", method: `get/${this.auctionId}`, parameters: { chunk: this.lastChunk, activeBid: this.activeBidId } })
        : await this.$store.dispatch("getRequest", { controller: "chat", method: `get/${this.auctionId}`, parameters: { chunk: this.lastChunk } });
      var self = this;
      if (self.scrollBottom || forceScroll) {
        self.$nextTick(function() {
          self.scrollToBottom();
        });
      } else {
        self.newMessageNotification = true;
      }
    },
    onScroll: function(event) {
      var currentScroll = event.target.scrollTop;
      if (event.target.scrollHeight - currentScroll == event.target.clientHeight) {
        this.scrollBottom = true;
        this.newMessageNotification = false;
      } else {
        this.scrollBottom = false;
      }
    },
    scrollToBottom: function() {
      var container = this.$el.querySelector(".chat-content");
      container.scrollTop = container.scrollHeight;
    },
  },
  computed: {
    currentUserId: function() {
      return this.$store.state.userId;
    },
    auctionId: function() {
      return this.$store.state.activeAuction ? this.$store.state.activeAuction.id : null;
    },
    activeBidId: function() {
      if (this.generalOnly) {
        return null;
      } else {
        return this.$store.state.activeBid ? this.$store.state.activeBid.offerId : null;
      }
    },
  },
  mounted: function() {
    this.loadNextChunk(true);
  },
  watch: {
    async refreshLogUser() {
      this.lastChunk = 1;
      await this.loadNextChunk(true);
    },
    async refreshLogRemote() {
      this.lastChunk = 1;
      await this.loadNextChunk(true);
    },
    async activeBidId() {
      this.lastChunk = 1;
      await this.loadNextChunk(true);
    },
  },
};
</script>
<template>
  <div id="chat-log">
    <transition name="slide-fade">
      <div v-on:click="scrollToBottom" v-if="newMessageNotification && !inlineChat" class="new-messages-notification content-bordered">New Messages!<i class="fas fa-arrow-alt-circle-down icon-right"></i></div>
    </transition>

    <div class="content-bordered chat-content" v-on:scroll.passive="onScroll($event)">
      <chat-message v-for="(item, index) in loadedMessages" :key="`row-${index}`" :messageData="item"></chat-message>
    </div>
  </div>
</template>
<style scoped>
#chat-log {
  height: calc(100% - 100px);
}
.inline-chat #chat-log {
  height: calc(100% - 25px);
}
#chat-log,
#chat-input-wrapper {
  padding: 0.3rem;
}

#chat-log > .chat-content {
  height: 100%;
  border-radius: 0px;
}
.content-bordered {
  overflow-y: auto;
}
.new-messages-notification {
  position: absolute;
  left: 20px;
  right: 20px;

  padding: 0.5rem;
  text-align: center;
  background-color: white;
  border-radius: 0px;
  color: #004996;
}
.slide-fade-enter-active {
  transition: all 0.1s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
.chat-content {
  padding: 0.5rem;
}
</style>
